module.exports = __webpack_public_path__ + "img/social-icon-youtube.a519aed0.svg";